{
  "name": "continuous-integration",
  "hostname": "ci.serveport.com",
  "default": null,
  "development": true,
  "production": false,
  "applicationName": "ServePort",
  "sourceVersion": "94961ca1555d0485d35917c2e19a1b4b445311e9",
  "errors": {
    "numRetries": 3
  },
  "urls": {
    "apiRootCoManage": "https://@.ci.serveport.com/_api/comanage/",
    "apiRootLpms": "https://@.ci.serveport.com/_api/lpms/",
    "apiRootSquirrel": "https://@.ci.serveport.com/_api/squirrel/",
    "apiRootRms": "https://@.ci.serveport.com/_api/rms/"
  },
  "stripe": {
    "key": "pk_test_sXNkfHf4SoQCOwMv6G26jnOd00AaAlGrWM"
  },
  "auth0": {
    "authorityRoot": "safarilaw-ci.auth0.com",
    "clientId": "HkeWLNJawgqfvTAiTFecz47pX0nq0WRM",
    "useLocalStorageCache": true
  },
  "auth": {
    "inactivityTimeout": 15,
    "inactivityWarning": 2
  },
  "statusApp": {
    "apiRootUrl": "https://@.ci.serveport.com/_api/maintenance/",
    "code": "_otSSDT9qMnGUM_kQKRl_NtGP_X0QjQfP2MT36jevuGnAzFuuPbGmA==",
    "cacheDurationInMinutes": 5
  },
  "featureFlags": {
    "inputRelativeValidation": true,
    "enableServiceOfProcessBusinessHours": true
  },
  "loggers": {
    "elmah": {
      "apiKey": "752d3d5a800541cd8dd1b5d747cc188a",
      "logId": "922a8891-8e01-45d9-867a-b1d29f57cd2e"
    },
    "appInsights": {
      "connectionString": "InstrumentationKey=9a6eabd7-934d-4e84-90a9-d8ab7fd0c5d9;IngestionEndpoint=https://eastus-1.in.applicationinsights.azure.com/;LiveEndpoint=https://eastus.livediagnostics.monitor.azure.com/;ApplicationId=6e844a9a-5781-4ddd-b80c-f015ca3ad736"
    }
  },
  "uiSettings": {
    "hasNavbar": true,
    "list": {
      "maxCountInMemory": 10000,
      "pageSize": 20
    },
    "maxSubtypesToShowInDropdown": 0,
    "updatePollFrequency": 3600,
    "showSwWarning": true,
    "richTextEditor": {
      "initializationTimeoutInMs": 2000
    },
    "file": {
      "tusUploadLimitInMb": 0,
      "maxCorrespondenceSizeAttachmentInMb": 20,
      "previewDialogTimeLimitInSeconds": 5,
      "downloadTarget": "_self"
    },
    "reports": {
      "key": "Z70R-XG6J5I-274219-0W0Y0F-734Y3H-5I460R-0H445W-4F6S27-2G5S1J-4P291I-2E5N"
    }
  },
  "signalR": {
    "hubs": [
      {
        "api": "rms",
        "name": "submissions",
        "url": "signalr/submissions"
      }
    ]
  }
}
